import i18n from '@i18next/i18n';

export const TranslationBullet = {
    l: i18n.t('项目符号'),
    n: i18n.t('正方形项目符号'),
    u: i18n.t('方块'),
    '✧': i18n.t('四角星项目符号'),
    ü: i18n.t('对勾项目符号'),
    Ø: i18n.t('箭头项目符号'),
};
